const FilesIllustraionIcon = () => {
  return (
    <svg
      width="121"
      height="77"
      viewBox="0 0 121 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7059 10.612L0.5 26.1284L23.3577 60.2836L46.5636 44.7672L23.7059 10.612Z"
        fill="#F2F3F7"
      />
      <path
        d="M34.5718 43.1519L34.3092 44.781L22.7725 43.1188L23.0351 41.4897L34.5718 43.1519Z"
        fill="#9EA5D1"
      />
      <path
        d="M28.7624 37.3403L30.417 37.5781L28.5825 48.9319L26.9258 48.6921L28.7624 37.3403Z"
        fill="#9EA5D1"
      />
      <path
        d="M18.146 22.9105C18.1626 22.9332 15.8379 24.5188 12.9527 26.4456C10.0675 28.3724 7.71585 29.9187 7.69931 29.8939C7.68276 29.8691 10.0075 28.2855 12.8927 26.3567C15.7779 24.4279 18.1191 22.8856 18.146 22.9105Z"
        fill="#9EA5D1"
      />
      <path
        d="M26.6711 20.7687C26.6876 20.7935 22.82 23.4067 18.034 26.6069C13.2481 29.8071 9.3474 32.381 9.33499 32.3582C9.32258 32.3355 13.1819 29.7182 17.9741 26.518C22.7662 23.3178 26.6545 20.7439 26.6711 20.7687Z"
        fill="#9EA5D1"
      />
      <path
        d="M28.382 23.3239C28.3985 23.3487 24.5309 25.9639 19.745 29.1641C14.9591 32.3644 11.0583 34.9382 11.0459 34.9134C11.0335 34.8886 14.897 32.2755 19.685 29.0732C24.473 25.8709 28.3654 23.2991 28.382 23.3239Z"
        fill="#9EA5D1"
      />
      <path
        d="M30.0922 25.881C30.1088 25.9058 26.2411 28.521 21.4552 31.7192C16.6693 34.9174 12.7686 37.4953 12.7686 37.4705C12.7686 37.4457 16.6176 34.8305 21.4056 31.6303C26.1936 28.4301 30.0757 25.8562 30.0922 25.881Z"
        fill="#9EA5D1"
      />
      <path
        d="M31.7959 28.4387C31.8125 28.4635 27.9448 31.0766 23.1589 34.2768C18.373 37.4771 14.4723 40.0509 14.4619 40.0261C14.4516 40.0013 18.3172 37.3882 23.1093 34.1879C27.9014 30.9877 31.7959 28.4138 31.7959 28.4387Z"
        fill="#9EA5D1"
      />
      <path
        d="M101.304 33.4985L81.8145 46.5298L101.011 75.2138L120.5 62.1825L101.304 33.4985Z"
        fill="#F2F3F7"
      />
      <path
        d="M110.432 60.8315L110.21 62.2001L100.521 60.8046L100.744 59.436L110.432 60.8315Z"
        fill="#9EA5D1"
      />
      <path
        d="M105.552 55.9507L106.942 56.1512L105.401 65.6858L104.009 65.4852L105.552 55.9507Z"
        fill="#9EA5D1"
      />
      <path
        d="M96.6272 43.842C96.6438 43.8668 94.6934 45.2002 92.2694 46.819C89.8455 48.4377 87.8682 49.7318 87.8517 49.7132C87.8351 49.6946 89.7875 48.3571 92.2095 46.7363C94.6314 45.1155 96.6107 43.8069 96.6272 43.842Z"
        fill="#9EA5D1"
      />
      <path
        d="M103.794 42.0334C103.811 42.0582 100.566 44.2579 96.5553 46.9433C92.545 49.6288 89.2627 51.7912 89.2462 51.7664C89.2296 51.7416 92.4747 49.542 96.485 46.8544C100.495 44.1669 103.771 42.0086 103.794 42.0334Z"
        fill="#9EA5D1"
      />
      <path
        d="M105.232 44.1794C105.248 44.2042 102.003 46.4038 97.9929 49.0914C93.9825 51.7789 90.7002 53.9372 90.6837 53.9124C90.6671 53.8876 93.9019 51.6983 97.9225 49.0107C101.943 46.3232 105.219 44.1566 105.232 44.1794Z"
        fill="#9EA5D1"
      />
      <path
        d="M106.667 46.3229C106.684 46.3477 103.437 48.5474 99.4284 51.2349C95.4201 53.9224 92.1357 56.0807 92.1192 56.0559C92.1027 56.0311 95.3477 53.8335 99.3581 51.1439C103.368 48.4543 106.653 46.3022 106.667 46.3229Z"
        fill="#9EA5D1"
      />
      <path
        d="M108.115 48.4753C108.131 48.5001 104.886 50.6977 100.876 53.3852C96.8653 56.0728 93.583 58.2311 93.5665 58.2083C93.5499 58.1856 96.795 55.9839 100.805 53.2963C104.816 50.6088 108.088 48.4505 108.115 48.4753Z"
        fill="#9EA5D1"
      />
      <path
        d="M70.4682 11.8726L49.2051 0.5L32.4634 31.8017L53.7266 43.1743L70.4682 11.8726Z"
        fill="#F2F3F7"
      />
      <path
        d="M50.0841 33.3754L48.7356 33.8364L45.3105 24.3742L46.6611 23.9111L50.0841 33.3754Z"
        fill="#9EA5D1"
      />
      <path
        d="M52.1523 26.5859L52.6445 27.9442L43.2422 31.163L42.75 29.8048L52.1523 26.5859Z"
        fill="#9EA5D1"
      />
      <path
        d="M58.8328 12.6256C58.8163 12.6566 56.6611 11.5361 54.0159 10.1241C51.3706 8.71212 49.2423 7.53994 49.2589 7.50893C49.2754 7.47792 51.4326 8.59842 54.0779 10.0104C56.7232 11.4224 58.8494 12.5925 58.8328 12.6256Z"
        fill="#9EA5D1"
      />
      <path
        d="M63.9369 18.2547C63.9204 18.2857 60.3506 16.4086 55.9638 14.0642C51.5771 11.7199 48.0362 9.79311 48.0528 9.7621C48.0693 9.73109 51.6371 11.6062 56.0238 13.9526C60.4106 16.299 63.9535 18.2237 63.9369 18.2547Z"
        fill="#9EA5D1"
      />
      <path
        d="M62.683 20.597C62.6665 20.628 59.0967 18.7529 54.7099 16.4065C50.3232 14.0601 46.7823 12.1354 46.7989 12.1044C46.8154 12.0734 50.3832 13.9505 54.7699 16.2949C59.1567 18.6392 62.6996 20.566 62.683 20.597Z"
        fill="#9EA5D1"
      />
      <path
        d="M61.4301 22.9393C61.4136 22.9704 57.8438 21.0953 53.457 18.7509C49.0703 16.4066 45.5294 14.486 45.546 14.4488C45.5625 14.4116 49.1302 16.2928 53.517 18.6372C57.9037 20.9816 61.4467 22.9083 61.4301 22.9393Z"
        fill="#9EA5D1"
      />
      <path
        d="M60.1772 25.2815C60.1606 25.3125 56.5909 23.4374 52.2041 21.093C47.8173 18.7487 44.2744 16.8219 44.293 16.7909C44.3117 16.7599 47.8773 18.635 52.2641 20.9793C56.6508 23.3237 60.1937 25.2505 60.1772 25.2815Z"
        fill="#9EA5D1"
      />
      <path
        d="M40.0699 33.824L32.7483 71.4082L31.7969 76.3285L80.6075 76.0928C82.7999 76.0824 84.744 74.1371 85.4452 71.2469L94.1029 35.7652C94.6385 33.5718 93.4638 31.2894 91.8009 31.2915L42.3863 31.3432C41.3108 31.3411 40.347 32.3583 40.0699 33.824Z"
        fill="#9EA5D1"
      />
      <g opacity="0.5">
        <path
          d="M40.0699 33.824L32.7483 71.4082L31.7969 76.3285L80.6075 76.0928C82.7999 76.0824 84.744 74.1371 85.4452 71.2469L94.1029 35.7652C94.6385 33.5718 93.4638 31.2894 91.8009 31.2915L42.3863 31.3432C41.3108 31.3411 40.347 32.3583 40.0699 33.824Z"
          fill="#474E67"
        />
      </g>
      <path
        d="M75.9311 68.8572L70.7605 27.2189C70.5536 25.5134 69.1907 24.2399 67.5836 24.2461L56.2496 24.2813C55.8284 24.286 55.4126 24.3764 55.0275 24.547C54.6424 24.7176 54.2961 24.9648 54.0097 25.2736L48.6323 30.9939L17.1122 31.1634C15.1866 31.1738 13.7057 32.9972 13.9601 35.0438L18.7606 73.5273C18.9674 75.2308 20.3304 76.5022 21.9332 76.5001L76.8763 76.3906C82.9942 76.5167 83.5795 74.7119 83.5795 74.7119C76.5557 76.2645 75.9311 68.8675 75.9311 68.8572Z"
        fill="#9EA5D1"
      />
      <g opacity="0.5">
        <path
          d="M52.2393 60.5298L50.3862 62.5186L36.1152 49.6846L37.9684 47.6958L52.2393 60.5298Z"
          fill="#F9F9FB"
        />
        <path
          d="M49.6104 47.2554L51.658 49.0974L38.7459 62.9589L36.6963 61.1169L49.6104 47.2554Z"
          fill="#F9F9FB"
        />
      </g>
    </svg>
  );
};

export default FilesIllustraionIcon;
